import { useState } from 'react'
import { collection, doc } from 'firebase/firestore'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import { Profile } from '../../../../../types/FirestoreUser'
import { getEffectiveServices } from '../../../../../utils/firebaseServiceContext'

export const useDiagnosisManagement = (uid: string | undefined) => {
  const [files, setFiles] = useState<FileList | null>(null)

  const uploadDiagnosisDocuments = async (
    profile: Profile
  ): Promise<Profile> => {
    if (!files || files.length === 0 || !uid) return profile
    const services = getEffectiveServices()

    const existingDocs = profile.diagnosisDocumentation || []
    const updatedDocs = [...existingDocs]

    for (let i = 0; i < files.length; i++) {
      const file = files.item(i)
      if (!file) continue

      const { id } = doc(collection(services.firestore, 'a'))

      const storageRef = ref(
        services.storage,
        `users/${uid}/documents/${id}.pdf`,
      )
      await uploadBytes(storageRef, file)
      const url = await getDownloadURL(storageRef)

      const newDoc = { url, uploadedAt: new Date().toISOString() }
      updatedDocs.push(newDoc)
    }

    return { ...profile, diagnosisDocumentation: updatedDocs }
  }

  return {
    files,
    setFiles,
    uploadDiagnosisDocuments,
  }
}
